import { MultipleOrigins } from 'models/MultipleOrigins/multipleOrigins.model';
import { serializable, alias, object, list, primitive } from 'serializr';

export class ProductRawMaterialTransportations {
  @serializable(alias('id', primitive()))
  id?: number;

  @serializable(alias('product_raw_material_id', primitive()))
  productRawMaterialId?: number;

  @serializable(alias('supplier_id', primitive()))
  supplierId?: number;

  @serializable(alias('type', primitive()))
  type?: string;

  @serializable(alias('temperature_control', primitive()))
  temperatureControl?: string;

  @serializable(alias('transportation_air', primitive()))
  transportationAir?: boolean;

  @serializable(alias('activity_label', primitive()))
  activityLabel?: string;

  @serializable(alias('createdAt', primitive()))
  createdAt?: string;

  @serializable(alias('updatedAt', primitive()))
  updatedAt?: string;

  @serializable(alias('supplier', primitive()))
  supplier?: string;

  @serializable(alias('co2e', primitive()))
  co2e?: string;

  @serializable(alias('normalised_co2e', primitive()))
  normalisedCo2e?: number;

  @serializable(alias('sum_of_normalised_co2e', primitive()))
  sumOfNormalisedCo2e?: number;

  @serializable(alias('leg_type', primitive()))
  legType?: string;

  @serializable(alias('origin_to_supplier_leg_type', primitive()))
  originToSupplierLegType?: boolean;

  @serializable(alias('supplier_to_pf_leg_type', primitive()))
  supplierToPfLegType?: boolean;

  @serializable
  processingFacilityName?: string;

  @serializable
  productId?: number;

  @serializable(alias('end_market_location', primitive()))
  endMarketLocation?: number;

  @serializable
  emission?: number;

  @serializable(alias('normalised_co2e_stage', primitive()))
  normalisedCo2eStage?: number;

  @serializable(alias('sum_of_normalised_co2e_stage', primitive()))
  sumOfNormalisedCo2eStage?: number;

  @serializable(alias('multiple_origin', list(object(MultipleOrigins))))
  multipleOrigins?: MultipleOrigins[];

  @serializable(alias('sum_of_co2e', primitive()))
  sumOfCo2e?: number;
}
